// extracted by mini-css-extract-plugin
module.exports = {"container":"ShareTab_container__2-V6Z","notShareableContainer":"ShareTab_notShareableContainer__PlBEE","message":"ShareTab_message__1wbKV","hidden":"ShareTab_hidden__1ldqX"};